var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Old-stuff",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feed",
    transform: "translate(-474.000000, -215.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-TRIGGER",
    transform: "translate(375.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rule---Home-language-is",
    transform: "translate(8.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-group",
    transform: "translate(8.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0622877,13.0622877 L15.0622877,7.93771229 C15.0622877,7.41982809 15.4821158,7 16,7 C16.5178842,7 16.9377123,7.41982809 16.9377123,7.93771229 L16.9377123,13.0622877 L22.0622877,13.0622877 C22.5801719,13.0622877 23,13.4821158 23,14 C23,14.5178842 22.5801719,14.9377123 22.0622877,14.9377123 L16.9377123,14.9377123 L16.9377123,20.0622877 C16.9377123,20.5801719 16.5178842,21 16,21 C15.4821158,21 15.0622877,20.5801719 15.0622877,20.0622877 L15.0622877,14.9377123 L9.93771229,14.9377123 C9.41982809,14.9377123 9,14.5178842 9,14 C9,13.4821158 9.41982809,13.0622877 9.93771229,13.0622877 L15.0622877,13.0622877 Z",
    id: "X"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSign);
export default __webpack_public_path__ + "static/media/add-sign.a650c76c42a3ceeb74134ac4855f3e11.svg";
export { ForwardRef as ReactComponent };